import { get } from 'lodash-es';
import axios from 'axios';
import store from '../store';

const commonReject = (error: any) => Promise.reject(error);

const getAxiosInstance = (interceptors?: {
  request?: Array<Array<(data: any) => any>>,
  response?: Array<Array<(data: any) => any>>,
}) => {
  const axiosInstance = axios.create();
  axiosInstance.defaults.withCredentials = true;

  interceptors?.request?.forEach((item) => {
    const [resolve, reject = commonReject] = item;
    axiosInstance.interceptors.request.use(resolve, reject);
  });

  interceptors?.response?.forEach((item) => {
    const [resolve, reject = commonReject] = item;
    axiosInstance.interceptors.response.use(resolve, reject);
  });

  return axiosInstance;
};

export const request = getAxiosInstance({
  request: [
    [(config: any) => {
      config.headers.common['data-report-app-id'] = store.appId;
      return config;
    }],
  ],
  response: [
    [(response) => {
      const {
        data,
        errors,
      } = get(response, 'data', {});

      if (errors && errors.length > 0) {
        const error = get(errors, '0.message');
        return Promise.reject(new Error(error));
      }

      return data;
    }],
  ],
});

export const wujiRequest = getAxiosInstance({
  response: [
    [(response) => {
      const {
        data,
        code,
        msg,
      } = get(response, 'data', {});

      if (code && code !== 200) {
        const error = new Error(msg);
        return Promise.reject(error);
      }

      return data;
    }],
  ],
});
